var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Selecione a Região de Atuação",
            "label-for": "tags-with-dropdown"
          }
        },
        [
          _c("b-form-tags", {
            staticClass: "mb-2",
            attrs: {
              id: "tags-with-dropdown",
              value: _vm.regioes,
              "no-outer-focus": ""
            },
            on: { input: _vm.alteraRegiao },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var tags = ref.tags
                  var disabled = ref.disabled
                  var addTag = ref.addTag
                  var removeTag = ref.removeTag
                  return [
                    tags.length > 0
                      ? _c(
                          "ul",
                          { staticClass: "list-inline d-inline-block mb-2" },
                          _vm._l(tags, function(tag, t) {
                            return _c(
                              "li",
                              { key: t, staticClass: "list-inline-item" },
                              [
                                _c(
                                  "b-form-tag",
                                  {
                                    attrs: {
                                      title: _vm.getUf(tag),
                                      disabled: disabled,
                                      variant: "info"
                                    },
                                    on: {
                                      remove: function($event) {
                                        return removeTag(tag)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.getUf(tag)))]
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          size: "sm",
                          variant: "outline-secondary",
                          block: "",
                          "menu-class": "w-100"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function() {
                                return [
                                  _c("b-icon", { attrs: { icon: "tag-fill" } }),
                                  _vm._v(" Selecione um estado\n          ")
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "b-dropdown-form",
                          {
                            on: {
                              submit: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return function() {}.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  label: "Pesquisar Região",
                                  "label-for": "tag-search-input",
                                  "label-cols-md": "auto",
                                  "label-size": "sm",
                                  description: _vm.searchDesc,
                                  disabled: disabled
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "tag-search-input",
                                    type: "search",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: _vm.search,
                                    callback: function($$v) {
                                      _vm.search = $$v
                                    },
                                    expression: "search"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-dropdown-divider"),
                        _vm._v(" "),
                        _vm._l(_vm.availableOptions, function(option) {
                          return _c(
                            "b-dropdown-item-button",
                            {
                              key: option.id,
                              staticClass: "list-inline d-inline-block mb-2",
                              on: {
                                click: function($event) {
                                  return _vm.onOptionClick({
                                    option: option,
                                    addTag: addTag,
                                    removeTag: removeTag
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(option.uf) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.availableOptions.length === 0
                          ? _c("b-dropdown-text", [
                              _vm._v(
                                "\n            Nenhum resultado encontrado\n          "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9875aaf8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9875aaf8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Tag.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9875aaf8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Tag.vue
// module chunks = 2